import { useCallback, useState } from 'react';
import { debounce } from 'lodash';
import { Form, message } from 'antd';
import { cloneDeep } from 'lodash';
import { ISelectParams } from './type';
import { UploadChangeParam, UploadFile } from 'antd/es/upload/interface';
import { fetchUploadModelSubmit } from './../../api/pages/smrtApi';
import { getFeatureResult } from './constants';

export const useSmrtHooks = () => {
    const [customize, setCustomize] = useState<boolean>(false);
    const [buttonStatus, setButtonStatus] = useState<boolean>(true);
    const [inputValue, setInputValue] = useState<string>();
    const [tabsIndex, setTabsIndex] = useState<number>(0);
    const [currentValue, setCurrentValue] = useState<string[]>([]);
    const [dataFeatureStatus, setDataFeatureStatus] = useState({ isInitial: true, isNone: [0, 1, 2, 3] });
    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const [errorFileStatus, setErrorFileStatus] = useState<boolean>(false);
    const [loadingStatus, setLoadingStatus] = useState<boolean>(false);

    const [resultData, setResultData] = useState<any>(() => {
        // resultData也需要做一个初始化
        const resultJson = sessionStorage.getItem('result-data');
        if (resultJson) {
            return JSON.parse(resultJson);
        }
    });
    const [resultStatus, setResultStatus] = useState<boolean>(() => {
        const status = sessionStorage.getItem('result-status');
        return !!status;
    });

    const [form] = Form.useForm();
    const [initialValues] = useState(() => {
        const formData = sessionStorage.getItem('paddle-model-form');
        if (formData) {
            const tempData = JSON.parse(formData);

            if (Object.keys(tempData).includes('file_name') && !!tempData.file_name.length) {
                const file_name = tempData.file_name.map((item: any) => {
                    if (item?.response?.code === '101' || item?.response?.code === 100) {
                        item.status = 'error';
                        setErrorFileStatus(true);
                    } else {
                        setErrorFileStatus(false);
                    }
                    return item;
                });
                tempData.file_name = file_name;
            }

            if (Object.keys(tempData).includes('g')) {
                if (!tempData.g.length) {
                    setDataFeatureStatus({ isInitial: true, isNone: [0, 1, 2, 3] });
                } else if (tempData.g.includes('无以上特点')) {
                    // 禁用1，2，3选项
                    setDataFeatureStatus({ isInitial: false, isNone: [3] });
                } else {
                    // 禁用4选项
                    setDataFeatureStatus({ isInitial: false, isNone: [0, 1, 2] });
                }
                setCurrentValue(tempData.g);
            }

            return tempData;
        }
        return {};
    });
    const [submitStatus, setSubmitStatus] = useState<boolean>(() => {
        // 需要通过sessionStorage判断是否满足要求
        if (!Object.keys(initialValues).length) {
            return false;
        }
        // e, g, file_name字段是非必传项，其余均是必传项
        for (let [key, value] of Object.entries(initialValues)) {
            if (!['e', 'g', 'file_name'].includes(key) && !value) {
                return false;
            }
            // 上传大文件需要判断status为done才为上传完成
            if (key === 'file_name') {
                if ((Array.isArray(value) && !value.length) || !value) {
                    return true;
                }
                if (Array.isArray(value) && !!value.length && value[0].status !== 'done') {
                    return false;
                }
            }
        }
        return true;
    });

    const onFileListChange = useCallback((params: UploadChangeParam) => {
        const tempFileList = params.fileList.map(item => {
            console.log('item:', item);
            
            if (item?.response?.code === '101' || item?.response?.code === 100) {
                item.status = 'error';
                setErrorFileStatus(true);
            } else {
                setErrorFileStatus(false);
            }
            if (item.status === 'error') {
                setErrorFileStatus(true);
                item.response = item?.response ? item?.response?.msg :'上传失败，请重新上传';
                return item;
            }
            
            return item;
        });
        setFileList(tempFileList);
    }, []);

    const handleCustomScene = (item: ISelectParams, element: ISelectParams['list'][0]) => {
        setCustomize(false);
        if (item.list[0].itemList.length === 3) {
            // 判断之前是否已经有自定义选项了，若有则覆盖，若没有则push添加
            item.list[0].itemList[2].lable = inputValue ?? '';
        } else {
            item.list[0].itemList.push({
                lable: inputValue ?? '',
                value: 'a3'
            });
        }
        // 自定义场景做一个sessionStorage的存储
        sessionStorage.setItem('application_scene', JSON.stringify({ a3: inputValue }));

        form.setFieldsValue({
            [element.name]: 'a3'
        });

        let event = new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true
        });

        let timer: any = null;
        const getOtherDom = () => {
            const activeDom = document.querySelector('.other-scene') as HTMLDivElement;
            if (activeDom) {
                activeDom.dispatchEvent(event);
                clearTimeout(timer);
            } else {
                timer = setTimeout(() => {
                    getOtherDom();
                }, 50);
            }
        };
        getOtherDom();
    };

    const handleFinish = async (values: any) => {
        const result = handleSubmitParams(values);
        setLoadingStatus(true);
        // 需要做一个scroll top的操作，用来居中加载状态
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        try {
            const data = await fetchUploadModelSubmit(result);
            if (data.body) {
                if (data.body.code !== 0) {
                    message.error(data.body.msg);
                    setLoadingStatus(false);
                    return;
                }
                setResultData(data.body);
                sessionStorage.setItem('result-data', JSON.stringify(data.body));
            }
        } catch (e) {
            // @ts-ignore
        }

        setResultStatus(true);
        sessionStorage.setItem('result-status', 'true');
        setLoadingStatus(false);
    };

    const handleSubmitParams = (values: any) => {
        // 需要处理dataFile 和 dataFeature两个参数
        let deep = cloneDeep(values);
        if (deep.file_name) {
            if (!!deep.file_name.length) {
                deep.file_name = deep.file_name[0]?.response?.file_name;
            } else {
                deep.file_name = undefined;
            }
        }
        // 对数据特点做一个映射

        deep.g = getFeatureResult(deep.g);
        return deep;
    };

    const onValuesChange = (changedValues: any, allvalues: any) => {
        // 需要用localAtorage存储表单项，防止刷新丢失信息
        sessionStorage.setItem('paddle-model-form', JSON.stringify(allvalues));
        for (let [key, value] of Object.entries(allvalues)) {
            if (!['e', 'g', 'file_name'].includes(key) && !value) {
                setSubmitStatus(false);
                return;
            }

            if (key === 'file_name') {
                if ((Array.isArray(value) && !value.length) || !value) {
                    setSubmitStatus(true);
                    return;
                }
                if (Array.isArray(value) && !!value.length && value[0].status !== 'done') {
                    setSubmitStatus(false);
                    return;
                }
            }
        }
        setSubmitStatus(true);
    };

    const handleCheckboxChange = debounce((value: any[]) => {
        if (!value.length) {
            setDataFeatureStatus({ isInitial: true, isNone: [0, 1, 2, 3] });
        } else if (value.includes('无以上特点')) {
            // 禁用1，2，3选项
            setDataFeatureStatus({ isInitial: false, isNone: [3] });
        } else {
            // 禁用4选项
            setDataFeatureStatus({ isInitial: false, isNone: [0, 1, 2] });
        }
        setCurrentValue(value);
        form.setFieldsValue({ g: value });
    }, 50);

    const normalFile = (e: any) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };

    return {
        customize,
        setCustomize,

        buttonStatus,
        setButtonStatus,

        inputValue,
        setInputValue,

        tabsIndex,
        setTabsIndex,

        currentValue,
        setCurrentValue,

        dataFeatureStatus,
        setDataFeatureStatus,

        fileList,
        setFileList,

        errorFileStatus,
        setErrorFileStatus,

        loadingStatus,
        setLoadingStatus,

        submitStatus,
        setSubmitStatus,

        form,
        initialValues,
        resultData,
        resultStatus,

        onFileListChange,
        handleCustomScene,
        onValuesChange,
        handleFinish,
        setResultStatus,
        setResultData,
        handleCheckboxChange,
        normalFile
    };
};
